import React from "react";
import { Card, Divider, List } from "antd";
import { useDarkMode } from "src/context/DarkModeContext";
import { ExplanationModel } from "src/data/models/ExplanationModel";
import "./ExplanationCard.css";

const ExplanationCard: React.FC<{ cardData: ExplanationModel }> = ({ cardData }) => {
  const { isDarkMode } = useDarkMode();

  return (
    <Card className={`explanation-card explanation-card-title ${isDarkMode ? "dark" : ""}`} title={cardData.title}>
      <p className="description">{cardData.description}</p>

      {cardData.bulletPoints && cardData.bulletPoints?.length > 0 && (
        <>
          <Divider />
          <List
            dataSource={cardData.bulletPoints}
            renderItem={(bullet) => (
              <List.Item className="bullet-item">
                <span>
                  <span className="bullet-icon">✧</span>
                  {bullet}</span>
              </List.Item>
            )}
          />
        </>
      )}

      {cardData.examples && cardData.examples.length > 0 && (
        <>
          <Divider />
          <List
            dataSource={cardData.examples}
            renderItem={(example) => (
              <List.Item className="example-text">{example}</List.Item>
            )}
          />
        </>
      )}
    </Card>
  );
};

export default ExplanationCard;
